/**
 * Generic Wizard Sidebar
 * Container for step navigation
 */

import React from 'react';
import { useWizardContext } from './WizardContext';
import WizardStepNavigation from './WizardStepNavigation';

const WizardSidebar: React.FC = () => {
  const { config } = useWizardContext();

  return (
    <aside className={`w-80 ${config.theme.sidebarBg} border-r border-gray-200 shadow-sm`}>
      <WizardStepNavigation />
    </aside>
  );
};

export default WizardSidebar;
